import { INGEST_LIMITS } from '@contracts/ingest';
import { OfferBox, OfferChip } from './OfferBox';
import type { SplitOfferState } from './useIngestInput';

/**
 * D61, D107: a sheet past the 500-row cap. "Chia lô" starts its first range; each next range is offered on the card
 * once the one before it is read ("Tạo lô tiếp"), one at a time.
 */
export function SplitOffer({ offer, busy, onAccept, onDismiss }: {
  offer: SplitOfferState; busy: boolean; onAccept: () => void; onDismiss: () => void;
}) {
  return (
    <OfferBox label="Đề nghị chia lô" dismissLabel="Bỏ qua chia lô" onDismiss={onDismiss}
      question={`Bảng có ${offer.rowCount} dòng, quá ${INGEST_LIMITS.rows} dòng một lô. Chia thành ${offer.ranges.length} lô?`}>
      <OfferChip onClick={onAccept} disabled={busy}>Chia lô</OfferChip>
    </OfferBox>
  );
}
